
import { useEffect, useState } from "react";

export default function AgendaPanel({agenda, agentStatus}) {

    const [selAgenda, setSelAgenda] = useState(0);

    function formatarDiaUI(yyyyMmDd) {
        if (!yyyyMmDd) return "";
        const [yyyy, mm, dd] = yyyyMmDd.split("-");
        return `${dd}.${mm}.${yyyy}`;
    }

    useEffect(() => {

        if (agenda.length === 0) return;
        if (!(agentStatus === 3 || agentStatus === 4)) return;

        const interval = setInterval(() => {setSelAgenda(prev => (prev + 1) % agenda.length);}, 5000);

        return () => clearInterval(interval);
        
    }, [agenda, agentStatus]);
    

    if (agenda.length === 0) {
        return (
            <div className="panel_box_agenda">
                <span className="panel_box_agenda_aviso">não há compromissos agendados ainda</span>
            </div>
        );
    }

    return (
        <div className="panel_box_agenda">
            <div className="panel_box_agenda_slide">
                {agenda.map((item, index) => {
                    const altura = `${100 / agenda.length}%`;
                    const isActive = index === selAgenda;
                    return (<span key={index} className={`panel_box_agenda_slide_item ${isActive ? "ativo" : ""}`} style={{ height: altura }}>{index + 1}</span>);
                })}
            </div>

            <div className="panel_box_agenda_frame">

                <div className="panel_box_agenda_frame_space"></div>

                <div className="panel_box_agenda_frame_box">
                    <div className="panel_box_agenda_frame_box1">
                        <span className="panel_box_agenda_frame_item1">{formatarDiaUI(agenda[selAgenda]?.dia)}</span>
                        <span className="panel_box_agenda_frame_item1">{agenda[selAgenda]?.hora}</span>
                    </div>

                    <div className="panel_box_agenda_frame_box2">
                        <span className="panel_box_agenda_frame_atendimento" style={{background: agenda[selAgenda]?.atendimento.toUpperCase() === "CONSULTA" ? "blue" : agenda[selAgenda]?.atendimento.toUpperCase() === "RETORNO" ? "purple": "green"}}>{agenda[selAgenda]?.atendimento.toUpperCase() === "CONSULTA" || agenda[selAgenda]?.atendimento.toUpperCase() === "RETORNO" ? agenda[selAgenda]?.atendimento.toUpperCase() : "EXAME"}</span>
                        <span className="panel_box_agenda_frame_action" style={{color: agenda[selAgenda]?.action === "AGENDADO" ? "green" : agenda[selAgenda]?.action === "CANCELADO" ? "red": "orange"}}>{agenda[selAgenda]?.action}</span>
                    </div>
                </div>

                <div className="panel_box_agenda_frame_space"></div>

                <div className="panel_box_agenda_frame_line">
                    <span className="panel_box_agenda_frame_item2">Paciente:&nbsp;</span>
                    <span className="panel_box_agenda_frame_item3">{agenda[selAgenda]?.nome}</span>
                </div>

                <div className="panel_box_agenda_frame_line">
                    <span className="panel_box_agenda_frame_item2">Contato:&nbsp;</span>
                    <span className="panel_box_agenda_frame_item3">{agenda[selAgenda]?.telefone}</span>
                </div>

                <div className="panel_box_agenda_frame_space"></div>
                <span className="panel_box_agenda_frame_item4">agendado em{" "}{agenda[selAgenda]?.scheduledAt.toLocaleDateString("pt-BR", {day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit"}).replace(",", "")}</span>
            </div>
        </div>
    );
}

